module.exports = __webpack_public_path__ + "html/customer-form.component.html";